import { MetricRangeType } from "@waterly/graphql-types";

import type { MetricRangeCardMetricRange } from "./metricRangeUtils";

export const normalizeIdealRangeForMetricRangeType = (
  idealRange: MetricRangeCardMetricRange,
  metricRangeType: MetricRangeType | null,
): MetricRangeCardMetricRange => {
  if (metricRangeType === MetricRangeType.Lower) {
    return { ...idealRange, rangeMax: null };
  }

  if (metricRangeType === MetricRangeType.Upper) {
    return { ...idealRange, rangeMin: null };
  }

  return idealRange;
};
